import * as React from 'react';
import { Grid, Checkbox, FormControlLabel } from '@material-ui/core';
import HourPicker from '../../../../ui-components/HourPicker/HourPicker';
import NumericField from '../../../../ui-components/NumericField/NumericField';
import { ActivityDefinitionDay, day } from '../../../../model/activities';

interface IProps {
    classes: any;
    day: day;
    onToggle: (val: boolean) => any;
    selected: boolean;
    value: ActivityDefinitionDay;
    onchange: (value: ActivityDefinitionDay) => any
}
export const DayRow = (props: IProps) => {
    return (<Grid container sm={12}>
        <Grid item sm={4}>
            <FormControlLabel className={props.classes.newActivityCheckBoxLabel}
                control={<Checkbox checked={props.selected} onChange={(e, val) => props.onToggle(val)} />}
                label={props.day.name}
            />
        </Grid>
        <Grid item sm={4}>
            <HourPicker disabled={!props.selected} className={props.classes.dayElement}
                label="Orario di inizio"
                value={props.value?.startTime}
                onChange={(h, m) => props.onchange({ ...props.value, startTime: { hours: h, minutes: m } })} />
        </Grid>
        <Grid item sm={2}>
            <NumericField disabled={!props.selected} className={props.classes.dayElement}
                label="Durata (minuti)"
                value={props.value?.duration}
                onChange={(val) => props.onchange({ ...props.value, duration: val })} />
        </Grid>
        <Grid item sm={2} style={{ paddingLeft: 10 }}>
            <NumericField disabled={!props.selected} className={props.classes.dayElement}
                label="Capienza"
                value={props.value?.capacity}
                onChange={(val) => props.onchange({ ...props.value, capacity: val })} />
        </Grid>
    </Grid>)
}